import { connect } from 'react-redux';
// import {
//   requestProductDetail,
//   requestCreateProductOffers,
//   createSavingGoal,
//   requestPaymentSchedule,
// } from 'src/redux/actions';
import PurchasePlans from './purchasePlans';

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(PurchasePlans);
